import type { TransactionRule } from '@carboncopyco/types';
import { TextBase } from '@carboncopyco/ui';
import classNames from 'classnames';
import { RulePreview } from '../RulePreview';

export interface TransactionRulePreviewProps {
  transactionRule: TransactionRule;
  disabled?: boolean;
}

export const TransactionRulePreview = ({
  transactionRule,
  disabled,
}: TransactionRulePreviewProps) => {
  return (
    <RulePreview>
      <RulePreview.Tooltip title={transactionRule.name}>
        <div
          className={classNames(
            'truncate ',
            disabled ? 'text-ds-natural-200' : 'text-ds-natural-600'
          )}
        >
          <TextBase
            label={transactionRule.name}
            color={disabled ? 'text-ds-natural-200' : 'text-ds-natural-600'}
          />
        </div>
      </RulePreview.Tooltip>
    </RulePreview>
  );
};
